<template>
  <b-modal @hidden="closeEmit" size="xl" :id="`ModalSemSimilar`" header-class="modal-cabecalho">
    <template slot="modal-header">
      <div class="bens-sem-similar-header">
        <h5 class="modal-title">
          Bens Sem Similar Nacional
        </h5>
        <div>
          <font-awesome-icon @click="closeModal" class="fa-x" icon="times" />
        </div>
      </div>
    </template>
    <div class="content">
      <div class="description">Selecione a opção de NCM mais adequada ao seu produto.</div>
      <div>
        <input
          v-model="search"
          class="searchSimilar"
          type="text"
          placeholder="Busque por NCM, descrição ou base legal"
        />
      </div>

      <div :key="key" class="similar-container">
        <table class="similarTable">
          <thead>
            <tr class="similarTableTitle">
              <th />
              <th>NCM</th>
              <th>Descrição</th>
              <th>Base Legal COMEX</th>
            </tr>
          </thead>
          <tbody>
            <tr
              @click="selecionaInput(index)"
              class="similarTableBody"
              v-for="(similar, index) in visibleSimilares"
            >
              <td>
                <input
                  :ref="`bssnRadio${index}`"
                  type="radio"
                  name="teste"
                  @change="handleSelect(similar)"
                />
              </td>
              <td>{{ similar.ncm }}</td>
              <td>{{ similar.descricao }}</td>
              <td v-html="strReplace(similar.base_legal, '<a ', '<a target=\'_blank\' ')" />
            </tr>
          </tbody>
        </table>
      </div>
      <div class="footer">
        <Pagination
          @selectedPage="visiblePageChange"
          :filteredArray="filteredSimilares"
          :firstItem="firstItem"
          :lastItem="lastItem"
        />
      </div>
    </div>
    <template slot="modal-footer">
      <BotaoPadrao
        arredondadoEsquerda
        class="botao-modal"
        nome="Cancelar"
        icone="times"
        :click="closeModal"
      />
      <BotaoPadrao
        arredondadoEsquerda
        class="botao-modal"
        nome="Salvar"
        icone="check"
        :click="handleSave"
        cor="azul"
      />
    </template>

    <!-- </div>
      </div> -->
    <!-- </div> -->
  </b-modal>
</template>

<script>
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";
import Pagination from "@/components/Pagination/Pagination.vue";
import stringFormatMixin from "@/mixins/stringFormatMixin";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "ModalIcmsInterestadual",
  mixins: [stringFormatMixin],

  components: {
    Pagination,
    BotaoPadrao
  },

  data() {
    return {
      search: "",
      itemsPerPage: 10,
      firstItem: 0,
      lastItem: 10,
      key: 0
    };
  },

  props: {
    id: String | Number,
    handleModalToogle: Function,
    isActive: Boolean,
    similares: Array || Object
  },

  created() {
    // this.handleModalToogle(false);
  },
  watch: {
    isActive() {
      if (this.isActive == true) {
        this.$root.$emit("bv::show::modal", `ModalSemSimilar`);
      } else {
        this.$root.$emit("bv::hide::modal", `ModalSemSimilar`);
      }
    }
  },

  computed: {
    ...mapGetters("resultado", ["getImpostos"]),

    filteredSimilares: function() {
      this.firstItem = 0;
      this.lastItem = 10;
      return this.similares
        ? this.similares.filter(similar => {
            return (
              similar.descricao.toLowerCase().match(this.search.toLowerCase()) ||
              similar.ncm.match(this.search) ||
              this.extractContent(similar.base_legal)
                .toLowerCase()
                .match(this.search.toLowerCase())
            );
          })
        : [];
    },

    visibleSimilares: function() {
      return this.filteredSimilares.slice(this.firstItem, this.lastItem);
    }
  },

  methods: {
    selecionaInput(index) {
      let ref = `bssnRadio${index}`;
      this.$refs[ref][0].click();
    },
    closeEmit() {
      this.handleModalToogle(false);
    },
    showConsole: function() {
      let teste = this.extractContent(this.similares[0].base_legal);
      console.log("teste", teste);
    },
    handleSelect: function(similar) {
      this.similares.map(p => (p.blIcmsSelected = false)); // marca todos os similares como falso
      similar.blIcmsSelected = true; // marca apenas o selecionado como verdadeiro
    },
    handleSave: function() {
      let selected = this.similares.find(similar => similar.blIcmsSelected == true); // encontra o similar selecionado
      this.$emit("similarSelecionado", this.id, selected);
      this.$root.$emit("bv::hide::modal", `ModalSemSimilar`);
    },
    closeModal() {
      this.$root.$emit("bv::hide::modal", `ModalSemSimilar`);
    },
    visiblePageChange: function(selectedPage) {
      this.firstItem = selectedPage * this.itemsPerPage - 10;
      this.lastItem = selectedPage * this.itemsPerPage;
      this.key += 1;
    }
  }
};
</script>

<style lang="scss" scoped>
h1 {
  margin-top: 0 !important;
}
.searchSimilar {
  width: 100%;
  border: 1px solid #9e9e9e;
  padding: 4px 8px;

  border-radius: 4px;
  margin-bottom: 12px;
}

.description {
  color: #9e9e9e;
  font-size: 14px;
  margin-bottom: 8px;
  margin-top: -10px;
}

table {
  margin-bottom: 12px;
}

.similarTable {
  width: -webkit-fill-available;

  tbody {
    height: 390px;
  }
}

.similarTableTitle {
  display: grid;
  grid-template-columns: 1fr 3fr 15fr 4fr;
}

.similarTableBody {
  cursor: pointer;
  display: grid;
  grid-template-columns: 1fr 3fr 15fr 4fr;
  user-select: none;
  > td {
    > input {
      cursor: pointer;
    }
  }
}

.buttonsContainer {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  button {
    float: right;
    color: var(--branco);
    text-decoration: none;
    border: 0;
    padding: 4px 16px;
    font-family: "Roboto Condensed";
    font-size: 13px;
    text-transform: uppercase;
    border-radius: 2px;
    position: relative;
    cursor: pointer;
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
    margin-left: 10px;

    &.salvar {
      background: var(--azul2);

      &:hover {
        filter: brightness(0.8);
      }
    }
    &.cancelar {
      background: #9e9e9e;

      &:hover {
        filter: brightness(0.8);
      }
    }
  }
}

.overlay-icms {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 50;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 100%;

  background-color: rgba(0, 0, 0, 0.5) !important;
}

.overlayContainer {
  margin: 0 10px;
}

.container {
  display: flex;
  flex-direction: column;
  background: var(--branco);
  width: 1000px;
  height: 620px;
  overflow: auto;
}

.content {
  display: flex;
  flex-direction: column;
  // padding: 10px 12px;
  background-color: var(--branco);
}
.similar-container {
  max-height: calc(100vh - 340px);
  overflow-y: auto;
  padding-right: 10px;
}
.bens-sem-similar-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
</style>
